export class ResultadoValidacion {
  constructor() {
    this.mensaje = "";
    this.errores = [];
    this.esValido = false;
  }

  mensaje: string;
  errores: any[];
  esValido: boolean;
}
